import { render, staticRenderFns } from "./open-toggle.vue?vue&type=template&id=8a381fe4&scoped=true&"
import script from "./open-toggle.vue?vue&type=script&lang=ts&"
export * from "./open-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./open-toggle.vue?vue&type=style&index=0&id=8a381fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a381fe4",
  null
  
)

export default component.exports